import {
  makeApiProvider,
  useApiQuery,
} from '@pflegenavi/shared-frontend/platform';
import { createContext } from 'react';
import type { IResidentApi } from './api';
import { ResidentApi } from './api';
import type { UseQueryOptions, UseQueryResult } from 'react-query';
import type {
  ResidentControllerQueryTypes,
  ResidentControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';

const ApiContext = createContext<IResidentApi | undefined>(undefined);
const { useApi: useResidentApi, ApiProvider: ResidentApiProvider } =
  makeApiProvider({
    name: 'Resident',
    ApiContext,
    newApi: (tenantId, auth, apiUrl) => new ResidentApi(tenantId, auth, apiUrl),
  });

export {
  useResidentApi,
  ResidentApiProvider,
  ApiContext as ResidentApiContexzt,
};
export type { IResidentApi } from './api';

const GET_RESIDENT_LIST_KEY = (params: {
  nursingHomeId: string;
  globalServiceProviderId: string;
}) => ['getResidentList', params];

export const useGetResidentList = (
  params: ResidentControllerQueryTypes['getResidentList'],
  options: UseQueryOptions<ResidentControllerResultTypes['getResidentList']>
): UseQueryResult<ResidentControllerResultTypes['getResidentList']> => {
  return useApiQuery(
    useResidentApi,
    GET_RESIDENT_LIST_KEY(params),
    (api) => {
      return api.getResidentList({
        params,
      });
    },
    options
  );
};
